<template>
  <section class="relative w-full overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100 py-8 sm:py-12 md:py-16 lg:py-20 mt-[-50px] sm:mt-0 md:mt-0 lg:mt-0">
    
    <div class="absolute inset-0 w-full h-full video-container">
      <video 
        autoplay 
        muted 
        loop 
        playsinline 
        class="absolute inset-0 w-full h-full object-cover"
        @loadeddata="videoLoaded = true"
      >
        <source src="/assets/images/hero-bg.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      
      
      <div class="absolute inset-0 bg-gradient-to-br from-gray-900/85 via-gray-900/70 to-gray-900/85 z-10"></div>
      
      
      <div class="absolute inset-0 opacity-5 z-11 pattern-grid-lg"></div>
    </div>

    
    <div class="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="text-center mb-8 sm:mb-12 md:mb-16 lg:mb-20 mt-14 sm:mt-0">
          <h1 class="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-white mt-2 mb-2 sm:mb-4 md:mb-6 leading-tight tracking-tight">
            <span class="block">{{ $t('hero.title1') }}</span>
            <span class="block text-blue-300">{{ $t('hero.title2') }}</span>
          </h1>
          <p class="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed px-4 sm:px-0">
            {{ $t('hero.subtitle') }}
          </p>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-4 md:gap-5 px-4 sm:px-0 -mt-8 sm:mt-1">
        <ActionCard
          v-for="(card, index) in actionCards"
          :key="index"
          :card="card"
          :index="index"
          @click="handleCardAction(card)"
          class="transform transition-all duration-300 hover:translate-y-[-4px]"
        />
      </div>
    </div>

    <div class="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-20 hidden sm:block">
      <div class="animate-bounce">
        <svg class="w-6 h-6 text-white/60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
        </svg>
      </div>
    </div>
  </section>
</template>

<script>
import ActionCard from "./ActionCard.vue";

export default {
  components: { ActionCard },
  data() {
    return {
      videoLoaded: false,
      actionCards: [
        {
          icon: 'M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z',
          title: 'hero.cardCyberTitle',
          description: 'hero.cardCyberDesc',
          route: 'cyber-incident',
          color: 'from-red-600 to-red-700',
          buttonText: 'hero.cardCyberBtn',
          accentColor: 'red'
        },
        {
          icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
          title: 'hero.cardComplaintTitle',
          description: 'hero.cardComplaintDesc',
          route: 'antic-complaint',
          color: 'from-blue-600 to-blue-700',
          buttonText: 'hero.cardComplaintBtn',
          accentColor: 'blue'
        },
        {
          icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2',
          title: 'hero.cardTrackTitle',
          description: 'hero.cardTrackDesc',
          route: 'followup',
          color: 'from-gray-700 to-gray-800',
          buttonText: 'hero.cardTrackBtn',
          accentColor: 'gray'
        },
        {
          icon: 'M13 10V3L4 14h7v7l9-11h-7z',
          title: 'hero.cardIncidentsTitle',
          description: 'hero.cardIncidentsDesc',
          route: '#objectives',
          color: 'from-indigo-700 to-indigo-800',
          buttonText: 'hero.cardIncidentsBtn',
          accentColor: 'indigo'
        }
      ]
    };
  },
  computed: {
    currentLang() {
      return this.$route.params.lang || this.$i18n.locale || 'en';
    }
  },
  methods: {
  handleCardAction(card) {
    if (card.route && card.route.startsWith('#')) {
      const element = document.querySelector(card.route);
      if (element) {
        element.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start' 
        });
      } 
    } 
    else if (card.route && typeof card.route === 'string') {
      const route = this.getRoute(card.route);
      
      this.$router.push(route).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          // navigation error
        }
      });
    } 
    else if (card.route && typeof card.route === 'object') {
      this.$router.push(card.route).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          // navigation error
        }
      });
    }
  },
    getRoute(routeName, routeParams = {}) {
    const params = { 
      lang: this.currentLang,
      ...routeParams 
    };

    // Routes that require human verification before access
    const gatedRoutes = {
      'cyber-incident': 'cyber',
      'antic-complaint': 'complaint',
      'followup': 'followup',
    };

    if (gatedRoutes[routeName]) {
      return { name: 'recaptcha-gate', params: { lang: this.currentLang, type: gatedRoutes[routeName] } };
    }

    return { name: routeName, params };
  }
}}
</script>

<style scoped>
.video-container {
  aspect-ratio: 21/9;
  min-height: 400px;
}

@media (min-width: 640px) {
  .video-container {
    min-height: 450px;
  }
}

@media (min-width: 768px) {
  .video-container {
    min-height: 500px;
  }
}

@media (min-width: 1024px) {
  .video-container {
    min-height: 600px;
  }
}

.pattern-grid-lg {
  background-image: 
    linear-gradient(to right, rgba(255, 255, 255, 0.1) 1px, transparent 1px),
    linear-gradient(to bottom, rgba(255, 255, 255, 0.1) 1px, transparent 1px);
  background-size: 40px 40px;
}

:deep(.action-card) {
  opacity: 0;
  transform: translateY(20px);
  animation: cardReveal 0.6s ease-out forwards;
}

:deep(.action-card:nth-child(1)) { animation-delay: 0.1s; }
:deep(.action-card:nth-child(2)) { animation-delay: 0.2s; }
:deep(.action-card:nth-child(3)) { animation-delay: 0.3s; }
:deep(.action-card:nth-child(4)) { animation-delay: 0.4s; }

@keyframes cardReveal {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

h1 {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  letter-spacing: -0.025em;
}

.hover-lift:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}

.glass-effect {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.video-loading {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
}

@media (max-width: 640px) {
  .video-container {
    aspect-ratio: 16/9;
  }
  
  .action-cards-grid {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

@media (prefers-contrast: high) {
  .video-container::after {
    background: rgba(0, 0, 0, 0.9);
  }
  
  :deep(.action-card) {
    border: 2px solid white;
  }
}

@media (prefers-reduced-motion: reduce) {
  .hover-lift:hover {
    transform: none;
  }
  
  :deep(.action-card) {
    animation: none;
    opacity: 1;
    transform: none;
  }
  
  .animate-bounce {
    animation: none;
  }
}

@media print {
  .video-container,
  .animate-bounce {
    display: none;
  }
  
  section {
    background: white !important;
    color: black !important;
  }
  
  h1, p, div {
    color: black !important;
  }
}

@media (min-width: 1920px) {
  .video-container {
    min-height: 700px;
  }
  
  h1 {
    font-size: 4.5rem;
  }
}
</style>